/**
 * Constantes para la nomenclatura de codigo de barras de productos pesables.
 *
 * Formato del barcode generado por la balanza:
 *   [PREFIJO][CODIGO_PRODUCTO][PESO]
 *    2 digitos  5 digitos       5 digitos  (= 12 digitos, + 1 digito verificador EAN-13)
 *
 * Ejemplo: 9900042000350
 *   Prefijo       → 99
 *   Codigo prod   → 00042  (producto #42 del tenant)
 *   Peso          → 00035  (0.035 kg = 35 gramos)
 *
 * Si en el futuro el prefijo debe ser configurable por tenant,
 * reemplazar PESABLE.PREFIJO por un valor de configuracion_sistema del JWT.
 */
export const PESABLE = {
  PREFIJO: '99',
  LONGITUD_CODIGO: 5,
  LONGITUD_PESO: 5,
  MAX_CODIGO_PRODUCTO: 99999,
};
